var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScannerCode = function SvgScannerCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.4H.8a.8.8 0 0 0-.8.8v3.2a.8.8 0 0 0 1.6 0V4H4a.8.8 0 0 0 0-1.6ZM23.2 16.8a.8.8 0 0 0-.8.8V20H20a.8.8 0 0 0 0 1.6h3.2a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.8-.8ZM23.2 2.4H20A.8.8 0 0 0 20 4h2.4v2.4a.8.8 0 0 0 1.6 0V3.2a.8.8 0 0 0-.8-.8ZM4 20H1.6v-2.4a.8.8 0 0 0-1.6 0v3.2a.8.8 0 0 0 .8.8H4A.8.8 0 0 0 4 20ZM4.8 5.6H3.2v12.8h1.6V5.6ZM7.998 5.6h-1.6v9.6h1.6V5.6ZM11.202 5.6h-1.6v9.6h1.6V5.6ZM14.4 5.6h-1.6v12.8h1.6V5.6ZM17.6 5.6H16v9.6h1.6V5.6ZM20.8 5.6h-1.6v12.8h1.6V5.6ZM7.998 16.8h-1.6v1.6h1.6v-1.6ZM11.202 16.8h-1.6v1.6h1.6v-1.6ZM17.6 16.8H16v1.6h1.6v-1.6Z",
    fill: "#999"
  })));
};
export default SvgScannerCode;